import { FC } from "react";
import { useSelector } from "react-redux";

import { Info } from "@livechat/design-system-icons";
import { Icon, Tooltip } from "@livechat/design-system-react-components";

import { selectIsAdmin } from "store/entities/agents";

const AgentRoleTooltip: FC = () => {
  const isOwner = useSelector(selectIsAdmin);
  return (
    <Tooltip kind="invert" triggerRenderer={<Icon source={Info} size="small" />}>
      {isOwner && (
        <>
          <strong>Admin</strong> has full access to global settings. They can invite new agents, make changes to
          subscriptions, and use all ticketing features.
          <br />
          <br />
        </>
      )}
      <strong>Agent</strong> has access to personal settings. They can use all ticketing features.
      <br />
      <br />
      <strong>Viewer</strong> can browse and read tickets without modifying them.
    </Tooltip>
  );
};

export default AgentRoleTooltip;
